import { request } from '../../utils/api';
import { API_URL } from '../../utils/constants';
import { AppThunk } from '../../utils/store-types';
import { TIngredientType } from '../../utils/types';
import { getItemRequest, getItemsFailed, getItemsSuccess } from '../actions';

type TResponse = { data: Array<TIngredientType> };

export function getItems(): AppThunk {
    return (dispatch, getStore) => {
        if (!getStore().fetch.data.length) {
            dispatch(getItemRequest());
            request<TResponse>(API_URL, {})
                .then((data) => {
                    dispatch(getItemsSuccess(data.data));
                })
                .catch((err) => {
                    dispatch(getItemsFailed(err));
                });
        }
    };
}
export default getItems;
